import React from 'react';
import { ChannelCallback } from './ChannelCallback';

/** /auth/linkedin/callback — the shared sign-in callback (ChannelCallback) for LinkedIn. */
const LinkedInCallback: React.FC = () => <ChannelCallback platform="linkedin" />;

export default LinkedInCallback;
